<template>
  <div class="card-padding">
    <div class="header-common view-flex view-flex-bottom">
      <div class="main">
        实时成员收入占比
      </div>
    </div>
    <br>
    <el-row>
      <div id="containerPie" />
    </el-row>
  </div>
</template>

<script>
import { Pie } from '@antv/g2plot'
export default {
  props: {
    headerTitle: {
      type: Object,
      default: () => {}
    },
    datastatics: {
      type: Array,
      default: () => []
    },
    money: {
      type: Boolean,
      default: false
    },
    lineChart: {
      type: Boolean
    },
    viewUrl: {
      type: String
    }
  },
  data () {
    return {
      pie: null
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    handleRoute: function () {
      if (!this.viewUrl) {
        return
      }
      this.$router.push(`${this.viewUrl}`)
    },
    async fetch () {
      const data = await this.$api.dashboard.getIndexOverview({})
      if (data) {
        this.pieData = data.percentage
        this.pieData.map((v) => {
          v.value = Number(v.value)
        })
        this.draw()
      }
    },
    draw () {
      let data = this.pieData
      console.log(data)
      console.log(this.pie)
      if (this.pie) {
        this.pie.update({
          data,
          angleField: 'value',
          colorField: 'name',
          height: 185,
          padding: 30,
          label: {
            type: 'outer',
            offset: '-30%',
            content: '{name}\n{percentage}',
            style: {
              fontSize: 12,
              textAlign: 'center'
            }
          },
          legend: false
        })
      } else {
        this.pie = new Pie('containerPie', {
          data,
          angleField: 'value',
          colorField: 'name',
          height: 185,
          padding: 10,
          radius: 0.75,
          label: {
            type: 'spider',
            labelHeight: 18,
            content: '{name}\n{percentage}',
            style: {
              fontSize: 12,
              textAlign: 'center'
            }
          },
          legend: false
        })
        this.pie.render()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-padding {
  padding: 15px;
  background: #fff;
  margin-bottom: 20px;
  .body {
    display: flex;

    .col {
      width: 33.3333%;
      margin-top: 30px;
    }
  }

  &.height190px {
    height: 190px;
  }

  .header-common {
    .main {
      font-size: 16px;
      color: black;
      font-weight: 500;
    }
    .subtitle {
      margin-left: 30px;
      font-size: 14px;
      color: grey;
      cursor: pointer;
    }
  }
  &.histogram {
    .main {
      font-size: 16px;
      color: black;
      font-weight: 500;
    }
    .sub {
      font-size: 12px;
      color: grey;
    }
    .body {
      margin-top: 36px;
    }
  }
}
@media only screen and (max-width: 1600px) {
  .card-padding {
    padding-bottom: 30px;

    .body {
      display: flex;

      .col {
        margin-top: 20px;
      }
    }

    .header-common {
      .main {
        font-size: 14px;
      }
      .subtitle {
        font-size: 12px;
      }
    }
  }
}
.top {
  color: #909399;
  font-size: 12px;
  display: flex;
  // justify-content: center;
  align-items: center;
}
.mid {
  font-size: 18px;
  color: #333;
}
.bottom {
  font-size: 12px;
  color: #909399;
}
</style>
